import { render } from "./CompanyServices.vue?vue&type=template&id=76da6d12&scoped=true"
import script from "./CompanyServices.vue?vue&type=script&lang=js"
export * from "./CompanyServices.vue?vue&type=script&lang=js"

import "./CompanyServices.vue?vue&type=style&index=0&id=76da6d12&lang=sass&scoped=true"

import exportComponent from "/home/frappe/ONEFM_Landing_page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76da6d12"]])

export default __exports__